<template>
    <section>
        <h2>FAQ</h2>
        <p>
            If you don't know where to start, we will guide you. Just click one of the circle below to start
        </p>
        <article 
            v-for="faq in faqs"
            :key="faq.title" >
            <router-link :to="{ name: 'step-2', params: { service:  faq.serviceParam} }">
                <figure>
                    <img :src="faq.img" alt="faq.title">
                </figure>
                <h4>{{faq.title}}</h4>
                <figcaption>{{faq.paragraph}}</figcaption>
            </router-link>
        </article>
    </section>
</template>

<script>

import { mapGetters } from 'vuex'
export default {
    name: 'faq-component',
    computed: {
        ...mapGetters({
            faqs: 'faqs'
        })
    }
}
</script>

<style lang="scss" scoped>
@import '../styles/_mixins.scss';

section {

    @include respond-to(tablet) {
        @include grid(4);
    }

    a {
        text-decoration: none;
    }

    h2,
    p {
        text-align: center;
        grid-column: 1/-1;
    }
    p {
        margin-bottom: $default_vmin;
    }

    figcaption {
        text-align: justify;

        @include respond-to(desktop) {
        font-size: 80%;
            text-align: center;
        }
    }
    h4 {
        margin: $small_vmin 0;
        font-size: 90%;
        text-transform: uppercase;
        line-height: 1;
    }

    > article {
        text-align: center;
        grid-column-end: span 1;
        margin-bottom: $default_vmin;

            figure {
                transition: transform .25s ease-out;
                &:hover {
                    transform: scale(1.05);
                    img {
                        filter: grayscale(0);
                    }
                }
                img {
                filter: grayscale(1);
                    border-radius: 50%;
                }
            }
    }
}

</style>